import { DataActionContainer } from "./Components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortAmountDownAlt, faSortAmountUpAlt } from '@fortawesome/free-solid-svg-icons';
import { useDataTable } from "../../hooks/useDataTable";
export const ColumnSort = ({col}) => {
    const {sortConfig, sort} = useDataTable();
    if(!col.sort) return;
    return (
        <DataActionContainer>
            {(sortConfig.key === col.key) && (
                sortConfig.align === "desc"?(
                    <FontAwesomeIcon icon={faSortAmountDownAlt} className="active" onClick={(e) => sort(col.key, "asc")}/>
                ):(
                    <FontAwesomeIcon icon={faSortAmountUpAlt} className="active" onClick={(e) => sort(col.key, "desc")}/>
                )
            )}
            
        </DataActionContainer>
    )
}